'use strict';

import transitionEnd from './transition-end-polyfill';
import {measure} from './promise-fastdom';

const _ = new WeakMap();

export default function WaitForTransition(node, property = null) {
    _.set(this, {
        node: node,
        property: property,
        handler: null,
    });
}

WaitForTransition.prototype.wait = function () {
    const o = _.get(this);
    return Promise.resolve()
        .then(measure(() => {
            return window.getComputedStyle(o.node).transitionDuration !== '0s';
        }))
        .then((hasTransition) => {
            return new Promise((resolve) => {
                if (!hasTransition) {
                    return requestAnimationFrame(resolve);
                }

                // remove previous listener
                o.handler && this.cancel();

                o.handler = (e) => {
                    if (e.target !== o.node) {
                        return;
                    }
                    if (o.property && o.property !== e.propertyName) {
                        return;
                    }
                    this.cancel();
                    resolve();
                };

                // listen
                o.node.addEventListener(transitionEnd, o.handler);
            });
        });
};

WaitForTransition.prototype.cancel = function () {
    const o = _.get(this);
    if (o.handler) {
        o.node.removeEventListener(transitionEnd, o.handler);
        o.handler = null;
    }
};